import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/types";

import CheckIcon from "@mui/icons-material/Check";
import CircularProgress from "@mui/material/CircularProgress";
import {
  AddUserButton,
  Avatar,
  ItemInfo,
  ItemName,
  ItemType,
  ResultItem,
  ResultsDropdown,
  SearchInput,
  SearchInputBox,
  SearchWrapper,
  SpinnerWrapper,
} from "./NavBarSearch.styles";

import Images from "config/Images";
import { toggleIdol } from "store/idol/idol.slice";
import { useNavigate } from "react-router-dom";
import { fetchUsers } from "store/user/searchUsers.slice";

const NavBarSearch = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { results, loading } = useSelector(
    (state: RootState) => state.searchUsers
  );
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const { togglingIds, idols } = useSelector((s: RootState) => s.idol);

  const wrapperRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = setTimeout(() => {
      if (query.trim().length) {
        dispatch(fetchUsers(query));
        setOpen(true);
      } else {
        setOpen(false);
      }
    }, 300);
    return () => clearTimeout(handler);
  }, [query, dispatch]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (user: SearchUserResult) => {
    navigate(`/profile/${user.id}`);
    setOpen(false);
    setQuery("");
  };

  return (
    <SearchWrapper ref={wrapperRef}>
      <SearchInputBox>
        <SearchIcon style={{ color: "#FE2F67" }} />
        <SearchInput
          placeholder=" Search users..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => results.length && setOpen(true)}
        />
      </SearchInputBox>

      {open && results.length > 0 && (
        <ResultsDropdown>
          {loading && (
            <ResultItem>
              <ItemName>Loading...</ItemName>
            </ResultItem>
          )}
          {results.map((u: SearchUserResult) => (
            <ResultItem key={u.id} onClick={() => handleSelect(u)}>
              <Avatar
                src={u.socialAvatarUrl || Images.DEFAULT_AVATAR}
                alt={u.name}
              />
              <ItemInfo>
                <ItemName>{u.name}</ItemName>
                <ItemType>{u.myself_type || u.organization_type}</ItemType>
              </ItemInfo>
              <AddUserButton
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(toggleIdol(u.id));
                }}
                disabled={togglingIds.includes(u.id)}
              >
                {togglingIds.includes(u.id) ? (
                  <SpinnerWrapper>
                    <CircularProgress size={18} thickness={5} />
                  </SpinnerWrapper>
                ) : (
                    idols.hasOwnProperty(u.id)
                      ? idols[u.id]
                      : u.isFollowing === 1
                  ) ? (
                  <CheckIcon fontSize="medium" />
                ) : (
                  <PersonAddAlt1Icon fontSize="medium" />
                )}
              </AddUserButton>
            </ResultItem>
          ))}
        </ResultsDropdown>
      )}
    </SearchWrapper>
  );
};

export default NavBarSearch;
